import { Component } from '@angular/core';
import { Rl1BoxService, T4BoxService } from '@app/modules/payroll/services';
import { BaseForm } from '@forms/base.form';
import { CustomDeductionType } from '@models/payroll/custom-deduction-type.model';

@Component({
    selector: 'app-form-request-custom-deduction-type',
    templateUrl: './request-custom-deduction-type.template.html',
    styles: `
        h5 {
            color: var(--grey-900);
        }
    `,
})
export class RequestCustomDeductionTypeForm extends BaseForm {
    selectedT4Boxes: number[] = [];
    selectedRl1Boxes: string[] = [];
    customDeductionType: CustomDeductionType = new CustomDeductionType();

    constructor(
        public rl1BoxService: Rl1BoxService,
        public t4BoxService: T4BoxService
    ) {
        super();
    }

    resetSelectedT4(): void {
        this.selectedT4Boxes = [];
    }

    resetSelectedRl1(): void {
        this.selectedRl1Boxes = [];
    }
}
